import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@teals/ui-web";
import type { DataSource } from "../../store/api/dataSourcesApi";
import {
  DS_TYPE_LABELS,
  DS_TYPE_BADGE_VARIANT,
  BYO_PROVIDER_LABELS,
} from "./constants";
import { formatRelativeTime } from "./relativeTime";
import {
  DSCard,
  CardHeader,
  CardTitle,
  CardRecords,
  AgentChipRow,
  AgentChip,
  CardFooter,
  MetaItem,
  DividerDot,
} from "./styles";

interface DataSourceCardProps {
  ds: DataSource;
  to: string;
}

const DataSourceCard: React.FC<DataSourceCardProps> = ({ ds, to }) => {
  const isByo = ds.dsType === "byo";

  const recordLabel =
    ds.recordCount != null && ds.recordCount > 0
      ? `${ds.recordCount.toLocaleString()} records`
      : "No records";

  const indexName = isByo
    ? (ds.connectionConfig?.index_name as string | undefined)
    : undefined;
  const providerLabel = ds.provider
    ? (BYO_PROVIDER_LABELS[ds.provider] ?? ds.provider)
    : null;

  return (
    <Link to={to} style={{ textDecoration: "none", color: "inherit" }}>
      <DSCard padding={20} elevation="sm">
        <CardHeader>
          <div>
            <CardTitle>{ds.name}</CardTitle>
            <CardRecords>{recordLabel}</CardRecords>
          </div>
          <Badge variant={DS_TYPE_BADGE_VARIANT[ds.dsType] as any} size="sm">
            {DS_TYPE_LABELS[ds.dsType]}
          </Badge>
        </CardHeader>

        {ds.agentIds.length > 0 && (
          <AgentChipRow>
            {ds.agentIds.map((id) => (
              <AgentChip key={id}>{id}</AgentChip>
            ))}
          </AgentChipRow>
        )}

        <CardFooter>
          {isByo && providerLabel ? (
            <MetaItem>
              {providerLabel}
              {indexName ? ` · ${indexName}` : ""}
            </MetaItem>
          ) : (
            <MetaItem>Org: {ds.orgName}</MetaItem>
          )}
          <DividerDot />
          <MetaItem>{formatRelativeTime(ds.updatedAt)}</MetaItem>
          <DividerDot />
          <MetaItem>Open →</MetaItem>
        </CardFooter>
      </DSCard>
    </Link>
  );
};

export default DataSourceCard;
